import {
  categoriesForCPGQuery,
  categoriesForStoreQuery
} from '@data/queries/categories/categoriesForWebsite'
import isServerSide from '@helpers/misc/isServerSide'
import useIsStore from '@hooks/useIsStore'
import {useApolloQuery} from '@packages/apollo-hooks'

import {
  getCategoriesAndProductsCPGsWeb_cached,
  getCategoriesAndProductsCPGsWeb_cachedVariables
} from './__generated__/getCategoriesAndProductsCPGsWeb_cached'
import {
  getCategoriesAndProductsWeb_cached,
  getCategoriesAndProductsWeb_cachedVariables
} from './__generated__/getCategoriesAndProductsWeb_cached'

export default function useCategoriesAndProducts({
  websiteId,
  menuId,
  format,
  preloadedCategories = {items: []}
}) {
  const isStore = useIsStore()

  const query = isStore ? categoriesForCPGQuery : categoriesForStoreQuery

  // On the serverside, we skip this query and return the categories loaded at getStaticProps
  // These categories are obtained from the store default menu
  const result = useApolloQuery<
    getCategoriesAndProductsWeb_cachedVariables | getCategoriesAndProductsCPGsWeb_cachedVariables,
    getCategoriesAndProductsWeb_cached | getCategoriesAndProductsCPGsWeb_cached
  >({
    query,
    variables: {websiteId, menuId, format},
    partial: true,
    omit: isServerSide()
  })

  if (isServerSide() || !result.data) {
    return {categories: preloadedCategories}
  }

  return result
}
